var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { CuiBaseComponent } from '@cicero/webui/lib/core/shared/base-component';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialService } from '../material.service';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { MaterialDialogComponent } from '../material-dialog/material-dialog.component';
var animationDuration = 200;
var MaterialListComponent = /** @class */ (function (_super) {
    __extends(MaterialListComponent, _super);
    function MaterialListComponent(route, router, materialService, dialog) {
        var _this = _super.call(this) || this;
        _this.route = route;
        _this.router = router;
        _this.materialService = materialService;
        _this.dialog = dialog;
        _this.materials = new BehaviorSubject([]);
        _this.visibleMaterials = [];
        _this.displayedMaterials = new BehaviorSubject([]);
        _this.page = 0;
        _this.numberOfResults = 0;
        _this.numberOfPages = 0;
        _this.numberOfHidden = 0;
        _this.queryDescriptor = '';
        _this.showQueryDescriptor = false;
        _this.materialStateChange = new Subject();
        _this.hideHandled = new FormControl(false);
        _this.hasLoaded = false;
        return _this;
    }
    Object.defineProperty(MaterialListComponent.prototype, "isOffline", {
        get: function () {
            return !window.navigator.onLine;
        },
        enumerable: true,
        configurable: true
    });
    MaterialListComponent.prototype.ngOnInit = function () {
        this.pushSubscription(this.setupMaterialFetching(), this.setupMaterialFiltering());
    };
    MaterialListComponent.prototype.setupMaterialFetching = function () {
        var _this = this;
        return this.route.queryParams
            .do(function () { return _this.hasLoaded = false; })
            .switchMap(function (queryParams) { return _this.materialService.search(queryParams, 0); })
            .subscribe(function (result) {
            _this.materials.next(result.materials);
            _this.queryDescriptor = result.query;
            _this.numberOfResults = result.numberOfResults;
            _this.numberOfPages = result.numberOfPages;
            _this.showQueryDescriptor = true;
            _this.hasLoaded = true;
            _this.page = 0;
            _this.addCovers(result.materials)
                .subscribe(function (materials) { return _this.materials.next(materials); });
        }, function () { return _this.error = 'Noget gik galt da vi hentede søgeresultaterne.'; });
    };
    MaterialListComponent.prototype.setupMaterialFiltering = function () {
        var _this = this;
        return Observable.merge(this.hideHandled.valueChanges, this.materialStateChange.filter(function () { return _this.hideHandled.value; }).delay(animationDuration), this.materials)
            .map(function () { return _this.materials.getValue(); })
            .map(function (materials) { return _this.filterMaterials(materials); })
            .subscribe(function (materials) { return _this.displayedMaterials.next(materials); });
    };
    MaterialListComponent.prototype.filterMaterials = function (materials) {
        if (!this.hideHandled.value) {
            this.numberOfHidden = 0;
            return materials;
        }
        var filteredMaterials = materials.filter(function (material) { return !material.localState; });
        this.numberOfHidden = materials.length - filteredMaterials.length;
        return filteredMaterials;
    };
    MaterialListComponent.prototype.loadNextPage = function () {
        var _this = this;
        if (this.page >= this.numberOfPages - 1) {
            return;
        }
        this.materialService.search(this.route.snapshot.queryParams, ++this.page)
            .subscribe(function (result) {
            _this.materials.next(_this.materials.value.concat(result.materials));
            _this.addCovers(result.materials)
                .subscribe(function (materials) { return _this.materials.next(_this.materials.value); });
        });
    };
    MaterialListComponent.prototype.showDialog = function (material) {
        var _this = this;
        var dialog = this.dialog.open(MaterialDialogComponent, {
            data: material,
            backdropClass: 'no-overflow-no-padding-backdrop'
        });
        dialog.componentInstance.materialStateChange.subscribe(function () { return _this.materialStateChange.next(); });
    };
    MaterialListComponent.prototype.undo = function (material) {
        this.materialService.undo(material).subscribe();
        this.materialStateChange.next();
    };
    MaterialListComponent.prototype.markFound = function (material) {
        this.materialService.markFound(material).subscribe();
        this.materialStateChange.next();
    };
    MaterialListComponent.prototype.markLost = function (material) {
        var _this = this;
        this.materialService.markLost(material).subscribe(null, function () { return _this.materialStateChange.next(); });
        this.materialStateChange.next();
    };
    MaterialListComponent.prototype.addCovers = function (materials) {
        var faustNumbers = materials.filter(function (m) { return m.faustNumber; }).map(function (m) { return m.faustNumber; });
        if (faustNumbers.length === 0) {
            return Observable.empty();
        }
        return this.materialService.getCovers(faustNumbers)
            .map(function (covers) {
            materials.forEach(function (material) {
                var cover = covers[material.faustNumber];
                if (cover) {
                    material.cover = cover.detail;
                }
            });
            return materials;
        });
    };
    return MaterialListComponent;
}(CuiBaseComponent));
export { MaterialListComponent };



// WEBPACK FOOTER //
// ./src/app/material/material-list/material-list.component.ts.pre-build-optimizer.js